import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Plug } from '@plone/volto/components/manage/Pluggable';
import { startFixaNascosti } from 'uniba-volto-persone/actions';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';
import { Icon } from 'design-react-kit';

class FixaNascostiToolbar extends Component {

    renderList = (title, list) => (
        <div style={{ marginBottom: 8 }}>
            <strong>{title}</strong>
            <div>
                {list.length === 0
                    ? <em>nessuno</em>
                    : (
                        <ul style={{ margin: 0, paddingLeft: 18 }}>
                            {list.map((item, i) => (
                                <li key={i}>
                                    {typeof item === 'object'
                                        ? JSON.stringify(item)
                                        : item}
                                </li>
                            ))}
                        </ul>
                    )
                }
            </div>
        </div>
    );


    componentDidUpdate(prevProps) {
        const { toast } = this.props.toastify;
        const prevResult = prevProps.fixaNascostiReducer?.result;
        const currentResult = this.props.fixaNascostiReducer?.result;

        if (!currentResult || currentResult === prevResult) return;

        const {
            pubblicati = [],
            nascosti = [],
            incompleti = [],
            errori = [],
        } = currentResult;

        const hasErrors = errori.length > 0;

        const toastStyle = {
            maxHeight: '200px',  // altezza massima
            overflowY: 'auto',   // abilita scroll verticale
            whiteSpace: 'normal' // evita che il testo venga troncato
        };

        const message = (
            <div style={toastStyle}>
                <p>Fixa Nascosti completato con {hasErrors ? "errori" : "successo"}:</p>
                {this.renderList('Pubblicati', pubblicati)}
                {this.renderList('Nascosti', nascosti)}
                {this.renderList('Incompleti', incompleti)}
                {this.renderList('Errori', errori)}
            </div>
        );

        if (hasErrors) {
            toast.error(message);
        } else {
            toast.success(message);
        }
    }

    hasPermissions() {
        const { actions } = this.props;
        return actions?.user?.some((ua) => ua?.id === 'toolbar-fixa-nascosti');
    }

    handleClick = (e) => {
        e.preventDefault();
        const { toast } = this.props.toastify;

        try {
            this.props.startFixaNascosti();
            toast.info('Procedura "Fixa Nascosti" avviata...');
        } catch (error) {
            toast.error('Impossibile avviare la procedura "Fixa Nascosti"');
            console.error(error);
        }

    };

    render() {
        if (!this.hasPermissions()) return null;

        const { intl } = this.props;
        const toolbar_title = intl.formatMessage({ id: 'fixa_nascosti' });

        return (
            <Plug pluggable="main.toolbar.top" id="fixa-nascosti-toolbar">
                <Link
                    to="#"
                    onClick={this.handleClick}
                    aria-label={toolbar_title}
                    alt={toolbar_title}
                    title={toolbar_title}
                    tabIndex={0}
                    className="deleteBlocks"
                    id="toolbar-fixa-nascosti"
                >
                    <Icon icon="it-password-invisible" color="secondary" size="md" title={toolbar_title} alt={toolbar_title} />
                </Link>
            </Plug>
        );
    }
}

const mapStateToProps = (state) => ({
    actions: state?.actions?.actions,
    breadcrumbs: state.breadcrumbs.items || [],
    fixaNascostiReducer: state.fixaNascostiReducer || {}
});

const mapDispatchToProps = {
    startFixaNascosti,
};

export default injectLazyLibs(['toastify'])(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
        (injectIntl(
            FixaNascostiToolbar
        ))
);
